import ModelUpload from './ModelUpload';

import './ModelUpload.scss';

export default ModelUpload;
